import { createApp } from 'vue';
import App from './App.vue';
import router from './router'; // Import router
import store from './store/store'; // Import Vuex store

// Variable to store the beforeinstallprompt event
let deferredPrompt;

window.addEventListener('beforeinstallprompt', (event) => {
  event.preventDefault(); // Prevent the default browser prompt
  deferredPrompt = event; // Save the event for later use
  store.commit('SET_INSTALL_PROMPT_AVAILABLE', true); // Update Vuex state to show the prompt option
});

// Function to trigger the Add to Home Screen prompt
function showAddToHomeScreen() {
  if (deferredPrompt) {
    deferredPrompt.prompt(); // Show the browser prompt
    deferredPrompt.userChoice.then(() => {
      deferredPrompt = null; // Reset the prompt
    });
  }
}

const app = createApp(App);

// Make the Add to Home Screen function globally available
app.config.globalProperties.$showAddToHomeScreen = showAddToHomeScreen;

app.use(router); // Register the router
app.use(store); // Register the Vuex store

app.mount('#app'); // Mount the app to the DOM
